export default __webpack_public_path__ + "static/media/IMG-20241005-WA0024.1324eea4.jpg";